import React, { useContext } from 'react'
import styled from '@emotion/styled'
import moment from 'moment'
import { colors } from 'style/theme'
import TimeAgo from 'react-timeago'
import { Button, Popconfirm } from 'antd'

const StyledCol = styled.span({
  fontWeight: 700,
  fontSize: '0.9rem'
})

const StyledDate = styled(StyledCol)({
  color: colors.brandTextLight
})

function ApiKeyListColumns( onDelete ) {
  
  return [
    {
      title: 'NAME',
      dataIndex: 'name',
      width: '30%',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render(name) {
        return <StyledCol>{name}</StyledCol>
      }
    },
    {
      title: 'USER',
      dataIndex: 'created_by',
      align: 'center',
      sorter: (a, b) => a.created_by.localeCompare(b.created_by),
      render(user) {
        return <StyledCol>{user}</StyledCol>
      }
    },
    {
      title: 'CREATED',
      dataIndex: 'create_date',
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
      render(create_date) {
        return (
          <StyledDate>
            <TimeAgo date={create_date} />
          </StyledDate>
        )
      }
    },
    {
      key: 'delete key',
      dataIndex: 'id',
      width: 100,
      render(id, key) {
        return (
          <Popconfirm
              title="Are you sure you want to delete?"
              placement="leftBottom"
              okText="Yes"
              cancelText="No"
              onConfirm={() => onDelete(key)}
            >
              <Button type="link" icon="delete"> DELETE</Button>
            </Popconfirm>
          
        )
      }
    }
  ]
}

export default ApiKeyListColumns
